import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {realtorsAroundProperty} from "@models/property";
import {getAvatar} from "@models/user";
import {isEmpty} from "@helpers/helpers";
import Avatar from "@atoms/avatar";
import Icon from "@atoms/icon";
import ButtonBase from "@atoms/button.base";
import CircleLoading from "@molecules/lotties/circle_loading";
import {realtorContactInfo} from "@models/user";
import {ContactEvents} from "@helpers/google_tag_events";
import PhoneIcon from '@icons/phone.svg';

const ContactAssignedRealtor = ({property_id, perContact, setContact, getPropertyContact, setHideAssignedRealtorsBox, setNotAssignedRealtors}) => {
    const [realtors, setRealtors] = useState([]);

    useEffect(() => {

        if (!isEmpty(property_id)) {
            realtorsAroundProperty(property_id).then(result => {
                if (result.realtors.length > 0) {
                    setNotAssignedRealtors(false);
                    setRealtors(result.realtors)
                } else {
                    getPropertyContact();
                }
            })
        }
    }, []);

    const getRealtorContactInfo = (realtor_id) => {
        setHideAssignedRealtorsBox(true);
        setContact({contactInfo: null});

        realtorContactInfo(realtor_id).then(result => {
            // Google Tag Manager Custom Event Trigger for contact
            const isPropertyList = (!isEmpty(perContact['isOnList']) && perContact['isOnList']);
            ContactEvents(isPropertyList);

            setContact(result);
        }).catch(error => {
            console.log(error)
        });
    };

    return (
        <div className="text-center mt-8 mt-lg-0 pb-24 pb-lg-0 px-24 px-lg-32">
            <h3 className="h2 mb-24">مشاورین این ملک</h3>

            {
                (realtors.length) ?
                    realtors.map((realtor, key) => {
                        let avatarPath = getAvatar('');
                        if (!isEmpty(realtor.avatar)) {
                            avatarPath = getAvatar(realtor.realtor_id);
                        }

                        return (
                            <Card key={key} className="d-flex align-items-center py-16">
                                <Avatar src={avatarPath} size="56"/>

                                <div className="d-flex align-items-start justify-content-between w-100">
                                    <Info className="mr-16">
                                        <h3 className="h4 d-flex align-items-center">
                                            <span>{realtor.realtor_name}</span>
                                        </h3>

                                        <div className="text-right h4-normal font-weight-light">
                                            {realtor.agency_name}
                                        </div>
                                    </Info>

                                    <ButtonBase variant="outline" size="circle-32" circle onClick={() => getRealtorContactInfo(realtor.realtor_id)} className="mr-8">
                                        <Icon width={16} height={16}>
                                            <PhoneIcon/>
                                        </Icon>
                                    </ButtonBase>
                                </div>
                            </Card>
                        )
                    })
                    :
                    <div className="mt-32" style={{height: 80}}>
                        <CircleLoading width={56} height={56}/>
                    </div>
            }

        </div>
    );
};

export default ContactAssignedRealtor;

// styles

const Card = styled.div`
    border-bottom: 1px solid ${props => props.theme.gray200};
	
	.icons {
		svg {
			transform: rotate(90deg);
		}
	}
	
    &:last-child {
        border-bottom: none;
    }
`;

const Info = styled.div`
    * {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;
